export default {
	head: {
		title: 'Blumar - Congresses & Events',
		description: 'Blumar Congress and Events is the official travel agency for 76º Congresso da SBD - dermatologia_2023. Find the best prices for hotel rooms and air tickets here. We have more than 30 years experience in the corporate events market.',
		keywords: 'Congresses, events, official agency, lodging, hotel, airfare, price comparison, tours, transfers.',
		ogDescription: 'Blumar Congress and Events is the official travel agency for  - . Find the best prices for hotel rooms and air tickets here. We have more than 30 years experience in the corporate events market.',
	},
	globalErrors: {
		serviceUnavailable: 'The service is currently unavailable. Please try again in a few moments.',
		serverErrorTitle: 'Something went wrong',
		backToSite: 'Back to the home page',
		loadFailed: 'This page could not be loaded.',
		tryAgain: 'Try again',
	},
	header: {
		subtitle: "Congresses, Conferences and Events all over Brazil",
	},
	navbar: {
		companyProfile: "Company Profile",
		calendar: "Calendar",
		accommodation: "Accommodation",
		flightBookings: "Flight Bookings",
		transportation: "Transportation",
		preAndPostTours: "Pre & Post Tours",
		localTours: "Local Tours",
		resume: "Resume",
		clientsArea: "Client's area",
		exit: 'Exit'
	},
	languageDropdown: {
		languages: {
			Pt: 'Português',
			En: 'English',
			Sp: 'Español',
		},
	},
	loginArea: {
		user: 'Login',
		pass: 'Password',
		enter: 'Enter',
		error: {
			title: 'Error!',
			message: 'Username or password is invalid'
		}
	},
	home: {
		aboveEventCalendarText: "Select an event below for more information about hotels, tours, air tickets, cancellation policies and more.",
		asideYearsTabText: "Select the year and see the events already confirmed:",
		confirmedEvents: {
			title: "Confirmed events",
			loading: "Loading events...",
			empty: "No confirmed events for this period.",
			reviewsLabel: "Trustindex reviews",
		},
		hero: {
			videoTitle: "Background video",
			headline: {
				strongStart: "Real commitment",
				middle: " at every stage",
				endStart: "from ",
				strongEnd: "planning to delivery",
			},
		},
	},
	footer: {
		ourContacts: "Our Contacts",
		contactLabel: "contact us",
		socialLabel: "social media",
		portfolioLabel: "Portfolio",
		address: "Blumar Brasil - Rua Siqueira Campos 43 - cob 2 - CEP: 22031-901 - Copacabana - Rio de Janeiro - Brasil - Tel: 21 2142-9300",
		privacyPolicy: "Privacy Policy",
	},
	cookieConsent: {
		message: '',
		acceptButton: '',
		privacyPolicy:'',

	},
	eventCard: {
		betweenDatesText: 'to',
		actionLabel: 'more about this event',
		pastLabel: 'past event',
	},
	eventHeader: {
		officialAgency: 'WE ARE THE OFFICIAL AGENCY OF THE EVENT',
	},
	eventPage: {
		periodConnector: 'to',
		optionLabels: {
			hotelReservation: 'Hotel Reservation',
			flightReservation: 'Flight Reservation',
			transferReservation: 'Transfer Reservation',
			localTours: 'Local Tours',
			aboutBrazil: 'General Information about Brazil',
			destinationInfo: 'City Information',
			eventWebsite: 'Event Website',
			visaAndVaccine: 'Visa and Vaccine',
		},
		officialAgency: {
			title: 'About Blumar',
			firstParagraph: eventName => `Blumar Turismo is the official agency for ${eventName} and the only agency authorized by the event organization to negotiate rates and make blocks on its behalf. Other agencies may contact you offering accommodation and airline tickets, however please note that those agencies are not authorized to negotiate on behalf of the event and do not have access to the blocks granted for it. Therefore, there is no guarantee for the attendee in case of payment, service or booking issues. The Blumar Congressos e Eventos team is available to answer requests or provide information by phone at 21 2142 9315 or by email at eventos@blumar.com.br. Thank you and enjoy the congress!`,
			secondParagraph: 'With more than 30 years of experience in the corporate events market, Blumar also offers, for your convenience, transfer services, local tours and pre and post congress tours.',
		},
	},
	prePostTours: {
		title: 'Pre & Post Tours',
		book: 'I want to book',
		included: 'The package includes:',
		excluded: 'Not included:',
		form: {
			title: 'Send your request',
			name: 'Name',
			email: 'E-mail',
			departureDate: 'Departure date',
			message: 'Message',
			close: 'close',
			submit: 'send request',
			sending: 'Sending request...',
			success: 'Request sent successfully!',
			failureTitle: 'Request not sent.',
			failureMessage: 'We could not send your request. Please try again later.',
		},
		tours: {
			5: {
				title: 'BUZIOS',
				description: [
					'A few decades ago, Búzios was beginning to become a beautiful place where rich and famous people went in search of peace and tranquility. In 1960, interest in the place increased with the visit of the French actress Brigitte Bardot, then a famous international film star who chose the town to relax for a few days. Since then, Búzios has become part of the international tourism itinerary. Búzios has good infrastructure, with internationally rated hotels and lodgings, as well as pleasant restaurants and bars. Today, the Peninsula still preserves some of the fishing village charm that has always given the town a special touch.',
				],
				included: [
					'2 nights at Pousada Pedra da Laguna',
					'Transfers from Rio de Janeiro Airport to Búzios',
					'Speedboat tour (6 hours)',
				],
				excluded: ['Airfare', 'Any item not previously mentioned'],
				price: [
					'From 6 installments of R$310.00 per person in a double room',
					'Total of R$1,860.00 per person',
				],
				notes: ['Price upon request'],
			},
			2: {
				title: 'IGUAÇU FALLS',
				description: [
					'Foz do Iguaçu is privileged to be located at the triple border of Brazil, Argentina, and Paraguay, and is known as the "City of Waterfalls," where the Paraná and Iguaçu Rivers form one of nature’s most stunning landscapes: the Iguassu Falls, visited by people from all corners of the world.',
					'The city also offers unmissable attractions, with emphasis on religious architecture, such as the Main Church, the Buddhist Temple, the Muslim Mosque, and the Itaipu Dam, the world’s largest in energy production.',
				],
				included: [
					'3 nights at Hotel Grand Carimã',
					'Transfers Foz Airport x Hotel',
					'Brazilian Falls',
					'Macuco Safari',
					'Bird Park',
				],
				excluded: ['Airfare', 'Any item not previously mentioned'],
				price: [
					'From 6 installments of R$445.00 per person in a double room',
					'Total of R$2,670.00 per person',
				],
				notes: ['Price upon request'],
			},
			6: {
				title: 'PARATY',
				description: [
					'Paraty is a charming colonial town, recognized as a Historical and Cultural Heritage site, preserving its impeccable architecture and enchanting natural scenery to this day. Walking through its car-free Historic Center is like traveling back in time, discovering stone streets, centuries-old mansions, and stories from the gold and coffee cycles — periods during which Paraty held great economic and port significance.',
					'The package includes 3 nights at the Sandi Hotel with breakfast, transfers between Rio de Janeiro Airport and Paraty, and complete experiences: a Netuno Vintage schooner tour through the calm waters of the bay and a City Tour with cachaça tasting, revealing the local culture and flavors.',
				],
				included: [
					'3 nights at Sandi Hotel with breakfast',
					'Transfers Rio de Janeiro Airport x Paraty',
					'Netuno Vintage Schooner Tour',
					'City Tour with Cachaça Tasting',
				],
				excluded: ['Airfare', 'Any item not previously mentioned'],
				price: [
					'From 6 installments of R$556.16 per person in a double room',
					'Total of R$3,337.00 per person',
				],
				notes: ['Price upon request'],
			},
			68: {
				title: 'Custom Package: Your Ideal Package',
				description: [
					'Do you want an exclusive itinerary to explore the city? We offer a personalized package with the best tourist options. Plan your trip with tailored details and discover the most enchanting attractions with all the comfort and convenience.',
				],
			},
			73: {
				title: 'ANAVILHANAS ECO LODGE - AMAZONAS',
				description: [
					'Experience an unforgettable journey in the Amazon! Enjoy 4 days and 3 nights at the exclusive Anavilhanas Lodge, including meals, transfers, and all hotel activities.',
					'Airfare and any items not mentioned are not included.',
				],
				price: [
					'💰 Price per person: R$10,220.00',
					'or 6 installments of R$1,703.33',
				],
				notes: ['Price upon request'],
			},
			72: {
				title: 'LENÇOIS MARANHENSES - BARREIRINHAS',
				description: [
					'Discover Barreirinhas, the gateway to the stunning Lençóis Maranhenses. Enjoy 4 nights at the charming Pousada Encantes do Nordeste, with breakfast included, experiencing comfort and tranquility along the banks of the Preguiças River. The package offers private transportation between São Luís Airport and Barreirinhas, ensuring convenience from the moment you arrive.',
					'During your trip, you will explore the best of the region with complete tours: the Lagoa Bonita Circuit, famous for its impressive dunes and unforgettable sunset; the Atins Lagoons Circuit (Canto do Atins), known for its crystal-clear lagoons and traditional cuisine; and the Santo Amaro Circuit (Betânia), one of the most preserved and peaceful areas of the park. At the end, your return to São Luís is also arranged with private transportation.',
				],
				included: [
					'4 nights in Barreirinhas at Pousada Encantes do Nordeste with breakfast',
					'Private transportation São Luís Airport / Barreirinhas',
					'Lagoa Bonita Circuit',
					'Atins Lagoons Circuit (Canto do Atins)',
					'Santo Amaro Circuit (Betânia)',
					'Private transportation Barreirinhas / São Luís',
				],
				excluded: ['Airfare', 'Any item not previously mentioned'],
				price: [
					'From 6 installments of R$791.00 per person in a double room',
					'Total of R$4,746.00 per person',
				],
				notes: ['Price upon request'],
			}
		},
	},
	datepicker: {
		previousDecade: 'Previous decade',
		previousYear: 'Previous year',
		previousMonth: 'Previous month',
		currentMonth: 'Current month',
		nextMonth: 'Next month',
		nextYear: 'Next year',
		nextDecade: 'Next decade',
		today: 'Today',
		selectedDate: 'Selected date',
		noDateSelected: 'No date selected',
		calendar: 'Calendar',
		calendarNavigation: 'Calendar navigation',
	},
	waitModal: {
		title: 'Blumar',
		message: 'Please wait',
		close: 'Close',
	},
	creditCardInfo:{
		title:'Payment Information',
		nameCreditCard:'Name (as in your credit card)',
		numberCreditCard:'Card numbers (only number )',
		code:'Card Security Code',
		codeInfo:'What is this?',
		expireDate:'Expiration date (month/year)',
		installments:'Number of payments ',
		receiptData:'Emission data for the Electronic Invoice',
		inscription:'Inscription',
		inscriptionCPF:'CPF',
		inscriptionCNPJ:'CNPJ',
		state:'State',
		uf:'State (Code)',
		city:'City',
		district:'District',
		street: 'Street',
		number: 'Number',
		complement:'Complement',
		zipCode:'Zip Code',
		book: {firstTry: 'book', retry: 'pay'}
	},
	hotelReservationCard: {
		checkinDate: 'Checkin Date',
		checkoutDate: 'Checkout Date',
		rooms: 'Rooms',
		guests: 'Guests',
		perRoom: 'Per room',
		adults: 'Adults',
		children: 'Children',
		age: (n) => n === 1 ? `${n} year` : `${n} years`,
		childrenAges: "Fill with children's Ages",
		bookHere: 'BOOK HERE',
		hotelSearch: 'Hotel Search',
		hotelSearchObs: 'Rates per room, per day in Brazilian Real (BRL)',
		continueButton: 'CONTINUE',
		installments: 'We pay in',
		installmentsWithoutTax: ' interest-free installments',
		changeReservation: 'Change  Reservation',
		sortBy: 'Sort by',
		noResultsFound: 'No results found.',
		mobileSearch: {
			changeSearch: 'change search',
			checkin: 'Arrival',
			checkout: 'Departure',
			double: 'Double',
			quadruple: 'Quadruple',
			resultTitle: 'Search Result',
			searchTitle: 'Hotel Reservation',
			single: 'Single',
			triple: 'Triple',
		},
	},
	hotelBookingPersonalInfo: {
		reservationData: 'Reservation`s data',
		hotel: 'Hotel',
		room: 'Apartment',
		rooms: 'Apartments',
		roomGuests: 'Guests for apartment',
		quantity: 'Quantity',
		allocationTypeSGL: 'Single',
		allocationTypeDBL: 'Double',
		allocationTypeTPL: 'Triple',
		allocationTypeQPL: 'QPL',
		checkin: 'Checkin date',
		checkout: 'Checkout date',
		dailyPrice: 'Daily Price',
		breakfast: 'Breakfast',
		breakfastIncluded: 'Breakfast included',
		breakfastNotIncluded: 'Breakfast not included',
		taxes: 'Taxes',
		total: 'total',
		fillFields: 'PLEASE FILL IN THE FIELDS BELOW',
		paxInfo: 'information about holder of reservation',
		pax: 'Holder of reservation',
		name: 'Name',
		email: 'Email',
		phone: 'Phone',
		country: 'Country',
		specialRequest: 'Special request',
		continue: 'CONTINUE',
		resume: 'BOOKING SUMMARY',
		guests: 'Guests',
		book: 'BOOK HERE',
		searchAgain: 'SEARCH AGAIN',
	},
	destinationInfo:{
		title:'CITY INFORMATIONS'
	},
	flightReservation: {
		flightReservationTitle: 'BUY AIRLINE TICKETS',
		departureDate: 'Departure Date',
		returnDate: 'Return Date',
		adults: 'Adults',
		children: 'Children',
		age: (n) => n === 1 ? `${n} old` : `${n} old`,
		babies: 'Babies',
		childrenAges: 'Fill in the ages of the Children',
		origin: 'Origin',
		destination: 'Destination',
		originPlaceholder: 'Enter your origin',
		destinationPlaceholder: 'Enter your destination',
		continueButton: 'CONTINUE',
	},
	flightRequestOffline: {
		title: 'FLIGHT RESERVATION',
		description: 'Blumar has negotiated excellent rates for flights inside Brazil for all participants',
		with: ' with ',
		discount: 'DISCOUNTS UP TO ',
		formTitle: 'Airline reservation form',
		descriptionForm: 'After filling up this form you will receive an email with other options of flights with value and payment form.',
		personalDetails: 'Personal details',
		fullName: 'FULL NAME',
		email: 'E-MAIL',
		phone: 'PHONE',
		departureAirport: 'DEPARTURE AIRPORT',
		class: 'Class',
		departureDate: 'DEPARTURE DATE',
		returnDate: 'RETURN DATE',
		period: 'PERIOD',
		mourning: 'Mourning',
		afternoon: 'Afternoon',
		evening: 'Evening',
		originPlaceholder: 'Enter your origin',
		send: 'SEND',
		invalidDate: 'Error! Departure date cannot be set later than the return date.',
		conclusion: {
			success: {
				title: 'Success!',
				message: 'Request sent successfully!'
			},
			fail : {
				title: 'Error sending request!',
				message: 'Unable to send your request! Try again later!'
			}
		},
		wait: 'Wait'
	},
	eventPromoterWebsite:{
		accessWebsite:'Access the event website: ',
		notFounded: 'Website not founded.'
	},
	transferReservation:{
		title:'TRANSFER RESERVATION',
		searchTitle: 'SEARCH TRANSFER',
		resume: 'BOOKINGS SUMMARY',
		search: 'Search',
		searchAgain: 'Search again',
 		wait: 'Searching...',
		responsible: 'Data from responsible of reservation',
		paxNumber: 'Nº of Passengers',
		date: 'Date',
		fullName: 'Full Name',
		name: 'Name',
		email:'E-mail',
		country:'Country',
		result: 'Result',
		noResult: 'No results found',
		resultTitle: 'Available transfer results',
		detail:{
			title: 'Booking detail',
			origin:'Pick up',
			destination: 'Drop off',
			pax: 'Passenger',
			birthdate: 'Birthdate',
			hour: 'Time',
			flightCompany: 'Air Carrier',
			flightNumber: 'Flight number',
			observation: 'Observations',
			price: 'Total',
			pricePerPerson: 'Price per person',
			select: 'Select',
			close: 'Close',
			add: 'Add',
			remove: 'Remove transfer',
			addAnotherTransfer: 'Add another transfer'
		},
		changeReservation: 'Change  Reservation',
	},
	hotelPrices: {
		breakfastIncluded: 'Breakfast included',
		breakfastNotIncluded: 'Breakfast not included',
		hotelInfo: 'About this hotel',
		book: 'Book',
		soldOut: 'Sold out',
		location: 'Location:',
		eventDistance: 'Event distance',
	},
	flightReservationCard: {
		origin: 'Origin',
		destination: 'Destination',
		checkinDate: 'Checkin Date',
		checkoutDate: 'Checkout Date',
		adults: 'Adults',
		kids: 'Kids',
		babies: 'Babies',
		bookHere: 'BOOK HERE'
	},
	visaAndVaccine: {
		title: 'Visa and Vaccine',
		vaccine: 'Vaccines: ',
		url: 'www.visitbrasil.com/key-information/health.html',
		vaccineInfo: 'To find out if you need a visa to travel to Brazil, ',
		click: 'click here.',
		vaccineMoreInfo: 'This information may be changed by brazilian government, so before travelling we suggest to seek current information in the applicable governmental agency of your country.',
	},
	aboutBrazil: {
		title: 'General information',
		menu: {
			health: 'Health',
			money: 'Money',
			time: 'Time',
			electricity: 'Electricity',
			language: 'Language',
			climate: 'Climate',
			tipping: 'Tipping',
			taxes: 'Taxes',
			brazillianFoodAndDrink: 'Brazilian food and drink',
			clothing: 'Clothing',
			generalSecurity: 'General security',
			shopping: 'Shopping',
			beaches: 'Beaches',
		},
		content: [
			{
				menu:'Health',
				content: 'There are no compulsory health requirements for entry into Brazil. Precautions are advised for Yellow Fever, Typhoid, Polio and Malaria. We suggest you contact your local G.P. for current advice and recommendations or telephone one of the organizations listed below. You are advised to have full medical insurance coverage. Please note that if you are entering Brazil via Peru, Ecuador or Colombia, you will be required to provide an up to date yellow fever vaccination certificate for immigration purposes. Avoid eating and drinking local products from street vendors and restaurants with suspect hygiene or refrigeration practices. It is advisable to drink only bottled water at all times.',
			},
			{
				menu: 'Money',
				content: 'The Brazilian currency is the REAL; 100 centavos = 1 real. Bank bills are in denominations of 100, 50, 20, 10, 5, 2; coins are 1.00 real; 50 centavos, 25 centavos, 10 centavos, 5 centavos and 1 centavo. All banks and exchange offices accept travelers checks and foreign currency. It is advisable to take US Dollar travelers checks or currency as this is more readily exchanged than other currency. There is a currency exchange black market, but you are strongly advised to ignore anyone who approaches you asking if you want to change money. Credit Cards - Access, MasterCard, American Express, Diners Club and Visa are accepted in the majority of hotels, shops and restaurants. Banking Hours - 10:00-16:00 Monday to Friday (may vary in some banks) ATM machines are also available in the main cities. There is a limited amount to be withdrawn daily. After 10:00PM it is only possible to withdraw up to 100,00 reais. Depending on the bank no withdrawals are allowed after 10:00 PM.',
			},
			{
				menu: 'Time',
				content: 'Brazil spans several time zones, however the Brazilian Standard Time is 3 hours earlier than G.M.T. and 2 hours earlier in the summer (Oct to Feb).',
			},
			{
				menu: 'Electricity',
				content: 'The electric current in most of Brazil is 110v. Many hotels have adaptors if necessary, although is recommended to bring your own travel adaptors',
			},
			{
				menu: 'Language',
				content: 'The official language is Portuguese. Some English is spoken, particularly in the main cities, but the nearest thing to a second language is Spanish with which you will generally be able to make yourself understood.',
			},
			{
				menu: 'Climate',
				content: 'The climate varies from arid scrubland inland to impassable tropical rainforest of the northerly Amazon jungle and the tropical eastern coastal beaches. The south is more temperate. Rainy seasons occur from January to April in the north (average number of days when there is some rain is 22); April to July in the northeast (average number of days when there is some rain is 14); December to March in the Rio/Sao Paulo area (average number of days when there is some rain is 10).',
			},
			{
				menu: 'Tipping',
				content: 'In most restaurants and bars a 10% service fee is added to the bill. More sophisticated places may add on 15%. If service is not included it will be stated at the bottom of the bill: "Serviço não incluído". Cab drivers do not expect a tip, but it is normal to round up the final price. You should be aware that the amount shown on the taximeter may not always correspond to the amount you are due to pay - look out for a separate sheet taped to the window which will tells you how much the amount on the meter equates to.',
			},
			{
				menu: 'Taxes',
				content: 'Airport taxes are usually included on the ticket price. To promote tourism and conventions, most of the hotels charge a non mandatory fee that runs from U$ 1,00 to U$ 7,00 per room per night depending on the hotel category as a contribution to the Convention Bureau. If guests want to deny the payment they must inform to the reception clerk upon check out.',
			},
			{
				menu: 'Brazilian food and drink',
				content: 'The most common dishes feature various meats, rice and the ubiquitous Brazilian black beans (feijão), whilst restaurants often offer all-you-can-eat barbecues and buffets. Brazil also has many regional varieties of cookery. An example is the Bahian cookery, which includes dishes such as : Vatapa (shrimps, fish oil, coconut milk, bread and rice), Sarapatel (liver, heart, tomatoes, peppers, onions and gravy). From Rio Grande do Sul a typical dish is Churrasco (a kind of barbecue). From the Amazon comes Tacaca (thick soup with shrimps and garlic). All alcoholic drinks are available, including excellent large style beers: Skol, Brahma, Antarctica and Cerpa. The most popular local alcoholic beverage is Cachaca, most commonly served as "Caipirinha" with slices of lime. Soft drinks include Guarana (a carbonated cola-like drink) and many varieties of excellent fruit-juices (sucos) including several vitamin-rich fruits you will never have heard of. Coffee tends to be served as a very strong. If you want to avoid sugar in coffee and juices, you should specifically ask for this. In Rio, you may see it’s common to ask for cocconut water in restaurants or kiosks by the beach, and "mate", a beverage that reminds an iced tea.',
			},
			{
				menu: 'Clothing',
				content: "Brazil's climate ranges from tropical in the north to temperate in the south. Throughout the country, however, dress is informal. Generally, light cotton shirts, shorts, dresses and trousers are ideal for day wear, whilst in the evenings long-sleeved shirts and leather shoes are normal. You will not normally need a jacket and tie in Brazil. In their winter (June/September) it is worth bringing something warm, as the temperature can be quite cool in the south of the country.",
			},
			{
				menu: 'General security',
				contentHtml: `
					<span>
						Welcome to Brazil! As in all major cities around the world, it’s important to be aware and take some basic
						precautions during your trip. With a few simple steps, you'll be able to fully enjoy your experience and focus on what
						truly matters: living unforgettable moments in our country.</span>
					<br><br>
					<span><b>Essential Guidelines for Your Safety and Comfort:</b></span>
					<br>
					<ul>
						<li><span><b>Frequent Recommended Areas:</b> Prioritize places like the conference center, main hotels, and the most
								iconic tourist spots, such as the neighborhoods of Barra da Tijuca, Leblon, Ipanema, and Copacabana. Be sure to
								visit Corcovado (Christ the Redeemer) and Sugarloaf Mountain, which are widely frequented by tourists and
								regularly patrolled, ensuring your peace of mind.</span></li>
						<li><span><b>Be Discreet:</b> Just like in other major metropolises, we recommend that you keep your personal items,
								such as phones, jewelry, and cameras, discreetly while moving around the streets. This helps minimize risks and
								provides greater peace of mind during your outings.</span></li>
						<li><span><b>Nighttime Travel:</b> Whenever possible, avoid walking alone at night. If you plan to go out, prefer to
								be accompanied and, if necessary, use ride-sharing services or reliable taxis, which are widely available in the
								region.</span></li>
					</ul>
					<span><b>Experience in Rio de Janeiro:</b></span>
					<br><br>
					<span>Thousands of international tourists visit Rio de Janeiro every year, whether for academic, cultural, or business
						events, and leave with incredible memories. With a few simple precautions, your experience in the "Marvelous City"
						will not only be safe but also enriched with opportunities for learning, connection, and unique discoveries.</span>
					<br><br>
					<span>We wish you an unforgettable stay and hope you make the most of all that Brazil has to offer. We are available to
						assist with anything you may need.</span>
					<style>
						ul {
							display: block;
							list-style-type: disc;
							margin-block-start: 1em;
							margin-block-end: 1em;
							padding-inline-start: 40px;
							unicode-bidi: isolate;
						}
					</style>
				`,
			},
			{
				menu: 'Beaches',
				content: "A great deal of Brazilian culture and Brazilians' spare time revolves around the beach. As a result the beaches can be great fun and very relaxing places. However, please bear the following in mind if going to the beach: beaches in and around the major cities tend to be quite crowded so the advice given above is especially applicable; never visit the beach after dark; always take a mat to lie on as sand flies are quite widely prevalent; please bear in mind that the sun in Brazil can be more direct and stronger than you will experience in Europe, so extra precautions are necessary; some areas, particularly in Rio, have dangerous undertows so you should stay near other bathers and observe the warning flags: red: dangerous / White - Water is safe.",
			},
			{
				menu: 'Shopping',
				content: 'As with the food, in a country the size of Brazil there are many local specialties for the shopper. In most major cities shopping centers stay open until late (up to 10.00 pm), while street shops close at 6pm. Good-quality arts and crafts are available at regular outdoor markets, which are colourful and entertaining places for tourists to visit.'

			}
		]
	},
	hotelInfo:{
		starRating: 'stars',
		description: 'Description',
		galleryTitle: 'Photo gallery',
		captionFallback: 'Caption',
		closeGallery: 'Close gallery',
		previewGalleryLabel: 'Hotel gallery',
		morePhotos: count => `More ${count} photos`,
	},
  endingBankTicketReservation: {
    endingReservationMessage: {
      title: "Your solicitation has been succesfully received.",
      text: "After payment of the ticket reservation will be confirmed. If we do not identify the payment your reservation will be automatically cancelled.",
			viewBankTicketButton: 'View Bank Ticket',
    }
  },
  conclusionBankTicketModal: {
    title: "Your solicitation has been succesfully received.",
    text: "After payment of the ticket reservation will be confirmed. If we do not identify the payment your reservation will be automatically cancelled.",
  },
	conclusionModal: {
		success: {
			title: 'Reservation made successfully.',
			message: "We'll send you an email with your reservation details shortly."
		},
		fail: {
			title: 'Reservation not made.',
			message: 'There was a problem completing the reservation, please try again later.'
		}
	},
	clientTable: {
		id: 'Id',
		date: 'Date',
		client: 'Client',
		description: 'Description',
		status: 'Status',
		informationUnavailable: 'Information unavailable'
	},
	conclusionErroClientFiles: {
		title: 'Error!',
		message: 'Error fetching client files.'
	},
	resumeTableHeaderLabels: {
		name: 'Events in ',
		start: 'From',
		end: 'To',
		local: 'Local'
	},
	resumeSubtitle: {
		title: 'RESUME',
		text: 'We have held congresses and events for over 30 years in different segments and we are a reference in the market. With operations and team displacement throughout the country, our company has already held more than 700 events, in 24 Brazilian cities distributed in 12 states, plus the Federal District.'
	},
	transferSection: {
		text: 'Take advantage of the convenience of the transfer options that Blumar Congressos e Eventos, the official agency for the {*}, offers to congress participants. Book now your transfer to the hotel, venue or airport. We accept bookings for groups or individuals.'
	},
	localTour: {
		title: 'Local Tours in',
		selectText: 'CHOOSE THE CITY TO VIEW THE TOURS:',
		selectOption: 'I want to book',
		description: 'Enjoy your stay during your moments of leisure. We offer a selection of special tours in the city of the event. Moreover, we also provide special programs in accordance with the profile of the event and special interests of the participants.',
		priceText: 'Price',
		form: {
			title: 'Make your request',
			hotel:'Hotel',
			name:'Name',
			email:'Email',
			country:'Country',
			date:'Date',
			message:'Observation',
			qtdPassenger:'Number of passengers',
			namePassenger:'Name of passengers',
			button: 'Request',

			success: {
				title: 'Local Tour successfully requested',
				message: 'We will contact you shortly to proceed with the booking.'
			},
			fail: {
				title: 'Error when booking Local Tour',
				message: 'There was a problem searching for Local Tours. Try again later.'
			}
		},
		fail: {
			title: 'Error when searching for Local Tours',
			message: 'There was a problem searching for Local Tours. Try again later.'
		}
	},
	invalidPaymentMessage: {
		bankTicket: {
			title: 'DEAR CUSTOMER',
			text: 'There was an error when issuing the ticket.'
		},
		creditCard: {
			title: 'DEAR CUSTOMER',
			text: 'Unauthorized payment by card. We ask that you please contact your card issuer, as possible security blocks may have prevented the charge. Certain of your understanding, BLUMAR TURISMO.'
		}
	},
	cancelConfirmationPolicy: {
		title: 'CONFIRMATION AND CANCELLATION',
		description: (value) => `By clicking on the "I agree" button, I declare that I agree that the amount of ${value} related to my reservation request will be immediately debited from my credit card, and I agree with Blumar's general conditions and cancellation and refund policy Tourism as below:`,
		bankticketDescription: 'Ao clicar no botão "Concordo", declaro que concordo com as condições gerais e política de cancelamento e reembolso da Blumar Turismo conforme abaixo:',
		firstCondition: 'Cancellations must be made in writing: eventos@blumar.com.br',
		termsConfirmation: 'I have read and agree with the terms above.',
	},
	privacyPolicy: {
		htmlContent: `
			<div class="privacy-policy-title">
				<span>Blumar Privacy Policy</span><hr>
			</div>
			<div class="privacy-policy-text">
				<p class="content-text">This Privacy Policy describes the practices of BLUMAR ("Blumar") regarding data collected through the website www.eventos.blumar.com.br ("Site"), in accordance with applicable laws.</p>
				<p class="content-text">This policy applies to data that identifies members, subscribers, customers, or visitors ("User") individually ("Personal Data") and other data provided by the User or collected during the use of the Site. In all cases, Blumar complies with all Brazilian legislation applicable to data protection.</p>
				<p>1. GENERAL CONDITIONS</p>
				<p class="content-text">1.1. All data from Users using the Site will be treated in accordance with Law No. 13.709, dated August 14, 2020 (General Data Protection Law).</p>
				<p class="content-text">1.2. By accepting this Privacy Policy, the User expresses their agreement to the collection and processing of their personal data by Blumar, including their name, email, phone number and/or mobile, address, date of birth and/or others.</p>
				<p class="content-text">1.3. By accepting this Privacy Policy, the User expresses their full and unreserved acceptance for all legal purposes. Thus, they declare that they have read carefully and completely this Privacy Policy. If the User disagrees with any of the terms and rules provided herein, they should not access and/or use the content.</p>
				<p class="content-text">1.4. Blumar reserves the right to change this agreement, with prior information to the Users, guaranteeing them the right to remove their consent for the processing of their data if they do not agree with the changes.</p>
				<p>2. DATA COLLECTED</p>
				<p class="content-text">2.1 Data is collected when entered or submitted voluntarily by the User when accessing the Site.</p>
				<p class="content-text">2.2. Information considered as identifiable Personal Data that we collect from the User's navigation on the Site:</p>
				- logs<br>
				- cookies, through the Google Analytics tool, which collects anonymously and for analytical purposes, the following data:<br>
				a) language; <br>
				b) country and city;<br>
				c) browser, operating system, and service provider; <br>
				d) screen resolution, type of device (desktop or mobile), mobile device model; and <br>
				e) page that the user navigates within the site, whether they are on the site at that moment, how the user accessed the Site (whether via search engine or directly through the URL of the site), search term used on the Site, time on the Site page.<br>
				<p class="content-text">2.3. The USER can learn more about Google Analytics at "How Google uses data when the user uses websites or apps from our partners," located at .</p>
				<p class="content-text">2.4. The data collected by Google through Google Analytics, as well as any use or processing carried out due to said collection will be the sole and exclusive responsibility of Google, Blumar being exempt from any responsibility arising therefrom.</p>
				<p class="content-text">2.5. If the User disagrees with the data collection by Google Analytics, they can disable it through the browser's Add-on, available at the link https://tools.google.com/dlpage/gaoptout?hl=en.</p>
				<p class="content-text">2.6. It is the User's duty to provide correct and updated information. We are not responsible for the accuracy, truthfulness, or lack thereof in the information provided by the User.</p>
				<p class="content-text">2.7. We partner with Microsoft Clarity and Microsoft Advertising to capture how you use and interact with our site through behavioral metrics, heatmaps, and session replay to improve and market our products/services. Website usage data is captured using own and third-party cookies and other tracking technologies to determine the popularity of products/services and online activities. Moreover, we use this information for website optimization, fraud/security purposes, and advertising. For more information on how Microsoft collects and uses your data, visit the Microsoft Privacy Statement (https://privacy.microsoft.com/en-US/privacystatement).</p>
				<p>3. LINKS TO THIRD-PARTY SITES</p>
				<p class="content-text">3.1. While browsing the Site, the User may be led, via hyperlink, to content or services or to other portals or platforms, which may collect their data and have their own privacy policy.</p>
				<p class="content-text">3.2. External hyperlinks do not constitute an endorsement by Blumar of the linked sites/environments or the information, products, or services contained therein. These hyperlinks are provided for your reference only.</p>
				<p class="content-text">3.3. Blumar will not have any responsibility for the material contained in these sites nor any association with their operators.</p>
				<p class="content-text">3.4. Blumar does not control these sites and is not responsible for their content or the use made by the User of them.</p>
				<p>4. HOW INFORMATION WILL BE USED</p>
				<p class="content-text">4.1. Blumar may use the data that have been collected and the records of activities on the Sites for the following purposes:</p>
				i. provision of contracted services, by Blumar or third parties;<br>
				ii. contact with potential customers; <br>
				iii. statistical analysis of results;<br>
				iv. promotion of services offered; <br>
				v. improvement of services on the site; <br>
				vi. improvement of the informed content; <br>
				vii. defense of interests in administrative and judicial processes; and/or <br>
				viii. compliance with a court order or administrative request.<br>
				<p class="content-text">4.2. The consent regarding the collection and processing of data provided by the User is given freely, expressly, individually, clearly, specifically, and legitimately.</p>
				<p class="content-text">4.3. If the User does not grant their consent for the preparation of the test, the services will not be made available to them.</p>
				<p class="content-text">4.4. If the User does not grant their consent for the optional purposes, related to sending information about hotels, tours, offers, and promotions, among other informative materials, the provision of services will continue to be carried out regularly.</p>
				<p class="content-text">4.5. The User acknowledges and agrees that their Personal Data collected by Blumar may be shared with third-party service providers contracted by the user, such as hotels, airlines, and other third parties contracted.</p>
				<p class="content-text">4.6. The collected data and recorded activities may also be shared with judicial, administrative, or government authorities, whenever there is a request, requisition, or court order.</p>
				<p class="content-text">4.7. Internally, our Users' data are accessed only by duly authorized professionals, respecting the principles of proportionality, necessity, and relevance to our objectives, in addition to the commitment to confidentiality and preservation of privacy under the terms of this Privacy Policy.</p>
				<p>5. DATA AND RECORDS STORAGE</p>
				<p class="content-text">5.1. The data and activity records collected will be stored in a secure and controlled environment for a minimum period of 6 (six) months, under the terms of Law 12.965, of April 23, 2014 (Civil Rights Framework for the Internet), considering the state of the art available.</p>
				<p class="content-text">5.2. Data will be deleted before this period if requested by the User, through the customer service channel indicated in item 6.1.</p>
				<p class="content-text">5.3. For auditing, security, or fraud control purposes, or when required by law or judicial decision, Blumar may maintain the history of registration of Users' data for a longer period, after which they will be deleted using secure disposal methods.</p>
				<p class="content-text">5.4. The collected data are stored on Blumar's own servers, located in Brazil, as well as in the cloud, which may involve, in this situation, the transfer or processing of data outside Brazil, in third countries.</p>
				<p>6. DATA DISPLAY, RECTIFICATION, AND DELETION</p>
				<p class="content-text">6.1. The User may request the display or rectification of their Personal Data via email viajepelobrasil@blumar.com.br.</p>
				<p class="content-text">6.2. Through the same customer service tool, the User can: a) Request the limitation of access and use of their Personal Data; b) Express their opposition to the use of their Personal Data; and c) Request the deletion of their Personal Data collected and recorded by Blumar.</p>
				<p class="content-text">6.3. If the User revokes their consent for fundamental purposes of the Site, the services and features of the same may become unavailable to that User.</p>
				<p>7. INTELLECTUAL PROPERTY</p>
				<p class="content-text">7.1 Each of the texts, photographs, designs, plans, images, videos, illustrations, icons, technologies, links, and other audiovisual or sound content, including the software of the Site, graphic designs, and source codes, are exclusively owned by Blumar or third parties who have authorized their use on the Site, being protected by laws and international treaties, with their copying, reproduction, or any other type of use prohibited, offenders being subject to the corresponding civil and criminal sanctions, under the terms of Laws 9.279/96, 9.609/98, and 9.610/98.</p>
				<p class="content-text">7.2 The brands, trade names, or logos of any kind presented through the Site are the property of Blumar or third parties who have allowed their use, such that the use of the Site does not constitute authorization for the User to cite such brands, trade names, and logos.</p>
				<p>8. APPLICABLE LAW AND JURISDICTION</p>
				<p class="content-text">8.1. This Privacy Policy and the relationship arising from the actions comprehended herein, as well as any dispute that arises as a result thereof, will be governed exclusively by Brazilian legislation.</p>
				<p class="content-text">8.2. The Central Court of the Capital District of the State of Rio de Janeiro is elected to settle any issue involving this document, with the parties renouncing any other, however privileged it may be or become.</p>
			</div>

			<div class="privacy-policy-title">
				<span>COOKIE POLICY</span><hr>
			</div>
			<div class="privacy-policy-text">
				<p>What are Cookies</p>
				<p class="content-text">Cookies are small text files that are placed on your electronic device when you visit our website. These small files serve to recognize, track, and store your navigation as an Internet user.</p>
				<p class="content-text">Cookies are widely used to ensure the most efficient operation of the website and to observe visit habits.</p>
				<p class="content-text">To enhance your experience, we use Cookies combined with other similar technologies.</p>
				<p>Why we use Cookies</p>
				<p class="content-text">We use Cookies for several reasons. Some are necessary for technical reasons, to ensure the proper functioning of the website.</p>
				<p class="content-text">Other Cookies offer a better experience on the website due to the memorization of some of your activities (including through our plugins, widgets, and embedded content), in addition to Cookies that allow for better navigation analysis and that display more relevant advertising.</p>
				<p>What types of Cookies</p>
				<p class="content-text">Cookies can be:</p>
				<p class="content-text">Proprietary Cookies - are Cookies set by us, or on our behalf, and used on our website;</p>
				<p class="content-text">Third-Party Cookies - are Cookies set by third parties, used inside or outside our website, which may have access to the data on your device but cannot collect your name, contact information, or other personal information unless you decide to disclose your data.</p>
				<p class="content-text">Essential or Strictly Necessary Cookies - These cookies are necessary for the website and cannot be turned off in our systems. They are usually set in response to actions that correspond to a request for services, such as setting your privacy preferences, logging in, or filling out forms. You can set your browser to block or alert you about these cookies, but some parts of the website will not work properly.</p>
				<p class="content-text">Performance Cookies - These Cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our website. They help us know which pages are most and least popular and see how visitors move around the website.</p>
				<p class="content-text">Functionality Cookies - These Cookies enable the website to provide enhanced functionality and personalization. They may be set by us (Proprietors) or by external providers (Third Parties), whose services we have added to our pages.</p>
				<p class="content-text">Advertising Cookies - These cookies may be set through the website by our advertising partners. They may be used by these companies to analyze and/or build a profile about your interests and optimize relevant ads on other websites.</p>
				<p class="content-text">Social Media Cookies - These Cookies are set by a range of social media services that we have added to our website to enable you to share our content with your friends and acquaintances. They are capable of tracking your browsing on other websites and creating a profile about your interests.</p>
				<p>How to change or block cookies</p>
				<p class="content-text">Most browsers are set to automatically accept cookies. However, you can change the settings to block cookies or alert you when a cookie is being sent to your device. There are several ways to manage cookies, and you can create a general block for cookies, block cookies from a specific site, or even block third-party cookies in relation to a site. Blocking all cookies will affect the functioning of your experience, as it will not be possible to identify your preferences and recommend relevant content and advertising.</p>
				<p class="content-text">Consult the instructions of your browser to learn more about how to adjust or change your settings, remembering that the desired setting should be replicated on all devices used to access the Services (such as computers, smartphones, tablets).</p>
				<p>Updates</p>
				<p class="content-text">We may update this Cookie Policy at any time. Any changes will take effect from the date they are published, or as required by law, and will be duly communicated through our website communication channels.</p>
			</div>
		`
	},
	staticPages: {
		companyProfile: {
			title: 'Who are we?',
			introduction: 'Blumar Tourism is a tourism operator with over 30 years of experience. As a market leader, we currently have active clients spread across every continent.',
			segmentsLabel: 'We operate in the following areas:',
			segments: [
				'Incoming Tour Operation',
				'Corporate and Incentive Travel',
				'Event and Congress Organization and Logistics',
			],
			operations: 'With a young, dynamic and multilingual team, we take care of all the tourism logistics for each event, from the moment we are contracted until the operation and closing. All processes are managed and supervised by highly qualified and experienced professionals, ready to respond to all requests. We focus on providing excellent quality services, standing out for our integrity and transparency in negotiations.',
			vision: 'Blumar aims to be recognized by its clients, suppliers and competitors as the most creative and reliable event company in the industry, and to remain among the market leaders in the main areas of incoming tourism, incentive travel and events.',
			mission: {
				title: 'Our Mission',
				text: 'To satisfy the needs of our clients, surpassing their expectations regarding leisure, culture and business, while providing accommodation, transportation and guided services of the highest possible quality.',
			},
			clients: {
				title: 'Number of clients',
				text: 'We have more than 1,000 active clients distributed across all continents.',
			},
			differentials: {
				title: "Blumar's Differentials",
				items: [
					{
						title: 'Experience and specialized knowledge',
						text: "Over 40 years in the industry, with in-depth knowledge of Brazil's tourism landscape and services covering every aspect of travel in Brazil.",
					},
					{
						title: 'Local knowledge',
						text: 'Our team knows the destination firsthand and can offer truly unique products and experiences. We are proud to have a multinational and multilingual team operating throughout Brazil.',
					},
					{
						title: 'Innovative products',
						text: 'We never stop creating. We strive to remain at the forefront of new product development, designing unique and unconventional packages and experiences.',
					},
					{
						title: 'Cutting-edge technology',
						text: 'An advanced web platform that simplifies the booking process for clients, providing easy access to the best hotels, tours and services available in Brazil.',
					},
					{
						title: 'Solid management and finances',
						text: 'Our market credentials are excellent. As a key client and preferred partner of all major hotels in Brazil, we can provide greater security for your operation.',
					},
					{
						title: 'Socially and environmentally responsible',
						text: 'As a company, Blumar is committed to supporting local communities in the destinations where it operates while minimizing its environmental impact.',
					},
				],
			},
			structure: {
				title: 'Events Department Structure',
				paragraphs: [
					"Our Events Team is made up of 15 highly experienced and committed professionals. The department's sales team makes the initial contact with clients, seeking to understand their exact needs and requirements and consequently develop the most personalized proposal possible. During our negotiations, we offer exclusive benefits and advantages, as well as flexibility in creating packages, discounts and a variety of payment methods.",
					"For each event, in addition to the operations team, we assign a specialist coordinator whose profile and experience are best aligned with the event's respective sector.",
					'Among our main functions, we provide a tailored service to the committee and company organizing the congress. We attentively provide full assistance to guests and speakers, taking care of travel logistics, helping to choose the best services and answering any questions.',
					'Such service is offered prior to the event as well as during it, at the event location itself. We can provide a Blumar Support Desk specially set up to meet all customer needs during the event.',
					'We operate events, congresses and symposia of different sizes throughout the country, both national and international and across a wide variety of sectors. Due to the excellent commercial relationship that Blumar has developed with the Tourism Trade, we have highly capable partners and also offer local support and mobile staff for each event operated.',
				],
			},
		},
		accommodation: {
			title: 'Accommodation',
			lead: 'Due to our credibility in the industry and the volume of business we undertake we can guarantee excellent negotiations, conditions and prices.',
			items: [
				{
					number: '1',
					title: 'Support and assistance on hotel selections',
					text: 'When Blumar is registered as the official travel agency, the staff analyzes the events profile and, along with the organizing committee, chooses which hotels will be part of the official list and which will be available to take reservations.',
				},
				{
					number: '2',
					title: 'Rate negotiation',
					text: "In addition to the congress, Blumar also has interest in bringing the largest possible number of participants to the event. In order to achieve this, we will negotiate with hotels' special rates in several price ranges for all types of clients.",
				},
				{
					number: '3',
					title: 'Flexibility of choice',
					text: 'To cater to different profiles, Blumar offers different options for hotels in various price ranges, categories and locations, always aiming to provide the highest customer satisfaction.',
				},
				{
					number: '4',
					title: 'Booking management system',
					text: 'We have an online reservation system for participants to create their bookings and receive confirmation vouchers instantly by email. We also offer a reservations report to the final client, which can be accessed by using a log in and password.',
				},
			],
		},
		flightBookings: {
			title: 'Flight Bookings',
			intro: [
				'We have a specialized department that negotiates, quotes and issues flights for events. Our staff is very trained and experienced with focus to offer the best deal for the client.',
				'We are an IATA accredited agency. We book and emit tickets for flights for the whole of Brazil and worldwide using the system Amadeus, E-Tam and the Gol API. For the events, we also offer:',
			],
			items: [
				{
					number: '1',
					title: 'Support in choosing official air transportation',
					text: "It is very beneficial to establish an official airline for each event. By doing that you can get more benefits and privileged conditions for the passages. With Blumar's experience in the market, we assist and monitor the entire process, from proposals and negotiations until the final choice.",
				},
				{
					number: '2',
					title: 'Negotiation of discount plane tickets',
					text: 'By being an Incoming Tour Operator of Tourism, Blumar has a great network with the air companies. Once appointed as the Official Agency of an event, we negotiate discounts of up to 15% on rates published on domestic air companies.',
				},
				{
					number: '3',
					title: 'Issuing of plane tickets for speakers and guests',
					text: 'Accounting for the highly personalized and specialized team that works with VIP services, Blumar will be at the disposition of the group or company to enter into contact with the speakers and guests in order to offer the best option for plane tickets. We will send standardized reports with the overall output of the ticket prices for the solicited dates.',
				},
			],
		},
		transportation: {
			title: 'Transportation',
			lead: 'We offer the services of:',
			items: [
				{
					number: '1',
					title: 'Transfer',
					text: 'For the comfort of the participants of the event, we offer the alternative of reserving transportation from the airport to the hotel and from the hotel to the airport. We are the only company who owns a transportation reservation system online, where the participant receives immediate confirmation.',
				},
				{
					number: '2',
					title: 'Shuttle',
					text: 'Many events offer its participants transportation from the hotels to the venue of the event with specialized staff to coordinate this service and guides for each bus. In this case, Blumar will be responsible for negotiating the best prices and conditions, developing the project and routes, and choosing the best companies on the market, providing more security and comfort to the participants.',
				},
				{
					number: '3',
					title: 'Others',
					text: 'We also rent the bus, micro-bus, van, sprinter, cars or armored cars. We negotiate with taxi companies and rental car companies so that they are at the disposal of the travelers. Blumar Tourism organizes the reception and assistance at the airport for passengers requiring information on transfers.',
				},
			],
		},
	},
	eventStamps: {
		BLUMAR_RECOMMENDS: 'Blumar Recommends',
		SHUTTLE: 'Shuttle',
		SPECIAL_OFFER: 'Special Offer',
		WALK: 'Walk',
	}
}



// WEBPACK FOOTER //
// ./src/assets/translationEn.js